var global = require('../internals/global');

module.exports = global.Promise;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/native-promise-constructor.js
// module id = 238
// module chunks = 48